module.exports = __webpack_public_path__ + "img/level_three.30b41b6e.png";